/**
 * Created by jv on 18/01/2017.
 */
const utils = require("Sources/utils/utils");

module.exports = class Person
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};
    
    this.firstname = options.firstname;
    this.lastname = options.lastname;

    this.phone = options.phone;
    this.mobile = options.mobile;
    this.email = options.email;
  };
};



// WEBPACK FOOTER //
// ./app/js/models/person.js